module.exports = __webpack_public_path__ + "static/media/1.c53d0045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/1.jpg
// module id = 392
// module chunks = 0